import { useMemo } from 'react';
import { useListingCompliance, type ListingComplianceInput } from 'hooks/use-listing-compliance';
import { formatMlsNumber } from './format-mls-info';

export interface UseMlsInfoOptions extends ListingComplianceInput {
  mlsNumber?: string | null;
}

export interface UseMlsInfoResult {
  mlsNumber?: string;
  formattedMlsNumber?: string;
  courtesyText?: string;
  buyerRepText?: string;
  isLoading: boolean;
  hasValue: boolean;
}

export function useMlsInfo(options: UseMlsInfoOptions): UseMlsInfoResult {
  const { mlsNumber, ...complianceInput } = options;
  const { providerId } = complianceInput;
  const { data, isLoading } = useListingCompliance(complianceInput);

  return useMemo(() => {
    const formattedMlsNumber = mlsNumber
      ? formatMlsNumber({ mlsNumber, providerId })
      : undefined;

    const hasValue = !!(formattedMlsNumber || data?.courtesyText || data?.buyerRepText);

    return {
      mlsNumber: mlsNumber || undefined,
      formattedMlsNumber,
      courtesyText: data?.courtesyText,
      buyerRepText: data?.buyerRepText,
      isLoading,
      hasValue,
    };
  }, [mlsNumber, providerId, data, isLoading]);
}
